/* ------------------------------------------------------------------------ */
/*		File: scroll.tsx                                                    */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* ------------------------------------------------------------------------ */

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            if (element) { element.scrollIntoView({ behavior: 'smooth' }) }
        } else { window.scrollTo(0, 0) }
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
